module.exports = __webpack_public_path__ + "static/media/icon-update.e9dc369c.svg";